<div class="container mx-auto px-4 py-6">
  <!-- Header -->
  <div class="mb-8">
    <h1 class="text-2xl font-bold text-gray-900">
      <ng-container *ngIf="wizardMode === 'new'">Nuevo Aplazamiento</ng-container>
      <ng-container *ngIf="wizardMode === 'continue' && continueInSameProject">Reversión de Aplazamiento</ng-container>
      <ng-container *ngIf="wizardMode === 'continue' && !continueInSameProject">Continuar desde Aplazamiento</ng-container>
    </h1>
    <p class="text-gray-600 mt-1">
      <ng-container *ngIf="wizardMode === 'new'">Castigar cartera temporalmente por aplazamiento de estudios</ng-container>
      <ng-container *ngIf="wizardMode === 'continue' && continueInSameProject">Descastigar cuotas y reactivar inscripción en el mismo proyecto</ng-container>
      <ng-container *ngIf="wizardMode === 'continue' && !continueInSameProject">Migrar cuotas aplazadas a nueva inscripción</ng-container>
    </p>
  </div>

  <!-- Mode Toggle (solo en paso 1) -->
  <div *ngIf="currentStep === 1" class="mb-6">
    <div class="flex rounded-lg overflow-hidden border border-gray-300">
      <button (click)="setMode('new')"
        [ngClass]="{'bg-yellow-500 text-white': wizardMode === 'new', 'bg-white text-gray-700': wizardMode !== 'new'}"
        class="flex-1 px-4 py-2 text-sm font-medium transition-colors">
        Nuevo Aplazamiento
      </button>
      <button (click)="setMode('continue')"
        [ngClass]="{'bg-green-500 text-white': wizardMode === 'continue', 'bg-white text-gray-700': wizardMode !== 'continue'}"
        class="flex-1 px-4 py-2 text-sm font-medium transition-colors">
        Continuar desde Aplazamiento
      </button>
    </div>
  </div>

  <!-- Stepper -->
  <div class="mb-8 overflow-x-auto">
    <div class="flex items-center justify-between min-w-[768px]">
      <!-- Modo new: 4 pasos fijos -->
      <ng-container *ngIf="wizardMode === 'new'">
        <ng-container *ngFor="let step of [1, 2, 3, 4]; let i = index; let last = last">
          <div class="flex items-center">
            <div [ngClass]="{
                'bg-green-600 text-white': currentStep === 4 && operationSuccess && step === 4,
                'bg-red-600 text-white': currentStep === 4 && !operationSuccess && step === 4,
                'bg-yellow-500 text-white': currentStep >= step && !(step === 4 && currentStep === 4),
                'bg-gray-200 text-gray-600': currentStep < step
              }"
              class="w-8 h-8 md:w-10 md:h-10 rounded-full flex items-center justify-center font-semibold text-sm flex-shrink-0 transition-colors duration-300">
              <span *ngIf="!(step === 4 && currentStep === 4)">{{ step }}</span>
              <svg *ngIf="step === 4 && currentStep === 4 && operationSuccess" class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
              </svg>
              <svg *ngIf="step === 4 && currentStep === 4 && !operationSuccess" class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </div>
            <span class="ml-2 text-xs font-medium whitespace-nowrap" [ngClass]="{'text-yellow-600': currentStep >= step, 'text-gray-500': currentStep < step}">
              {{ step === 1 ? 'Seleccionar' : step === 2 ? 'Cuotas' : step === 3 ? 'Confirmar' : 'Resultado' }}
            </span>
          </div>
          <div *ngIf="!last" class="flex-1 h-1 mx-4" [ngClass]="{'bg-yellow-500': currentStep > step, 'bg-gray-200': currentStep <= step}"></div>
        </ng-container>
      </ng-container>

      <!-- Modo continue: pasos dinámicos según continueInSameProject -->
      <ng-container *ngIf="wizardMode === 'continue'">
        <!-- Mismo proyecto: 4 pasos -->
        <ng-container *ngIf="continueInSameProject">
          <ng-container *ngFor="let stepInfo of [{n:1,l:'Seleccionar'},{n:2,l:'Destino'},{n:3,l:'Confirmar'},{n:4,l:'Resultado'}]; let last = last">
            <div class="flex items-center">
              <div [ngClass]="{
                  'bg-green-600 text-white': currentStep === 4 && operationSuccess && stepInfo.n === 4,
                  'bg-red-600 text-white': currentStep === 4 && !operationSuccess && stepInfo.n === 4,
                  'bg-green-500 text-white': currentStep >= stepInfo.n && !(stepInfo.n === 4 && currentStep === 4),
                  'bg-gray-200 text-gray-600': currentStep < stepInfo.n
                }"
                class="w-8 h-8 md:w-10 md:h-10 rounded-full flex items-center justify-center font-semibold text-sm flex-shrink-0 transition-colors duration-300">
                <span *ngIf="!(stepInfo.n === 4 && currentStep === 4)">{{ stepInfo.n }}</span>
                <svg *ngIf="stepInfo.n === 4 && currentStep === 4 && operationSuccess" class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                </svg>
                <svg *ngIf="stepInfo.n === 4 && currentStep === 4 && !operationSuccess" class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </div>
              <span class="ml-2 text-xs font-medium whitespace-nowrap" [ngClass]="{'text-green-600': currentStep >= stepInfo.n, 'text-gray-500': currentStep < stepInfo.n}">
                {{ stepInfo.l }}
              </span>
            </div>
            <div *ngIf="!last" class="flex-1 h-1 mx-4" [ngClass]="{'bg-green-500': currentStep > stepInfo.n, 'bg-gray-200': currentStep <= stepInfo.n}"></div>
          </ng-container>
        </ng-container>

        <!-- Nuevo proyecto: 6 pasos -->
        <ng-container *ngIf="!continueInSameProject">
          <ng-container *ngFor="let stepInfo of [{n:1,l:'Seleccionar'},{n:2,l:'Destino'},{n:3,l:'Valor'},{n:4,l:'Plan'},{n:5,l:'Confirmar'},{n:6,l:'Resultado'}]; let last = last">
            <div class="flex items-center">
              <div [ngClass]="{
                  'bg-green-600 text-white': currentStep === 6 && operationSuccess && stepInfo.n === 6,
                  'bg-red-600 text-white': currentStep === 6 && !operationSuccess && stepInfo.n === 6,
                  'bg-yellow-500 text-white': currentStep >= stepInfo.n && !(stepInfo.n === 6 && currentStep === 6),
                  'bg-gray-200 text-gray-600': currentStep < stepInfo.n
                }"
                class="w-8 h-8 md:w-10 md:h-10 rounded-full flex items-center justify-center font-semibold text-sm flex-shrink-0 transition-colors duration-300">
                <span *ngIf="!(stepInfo.n === 6 && currentStep === 6)">{{ stepInfo.n }}</span>
                <svg *ngIf="stepInfo.n === 6 && currentStep === 6 && operationSuccess" class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                </svg>
                <svg *ngIf="stepInfo.n === 6 && currentStep === 6 && !operationSuccess" class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </div>
              <span class="ml-2 text-xs font-medium whitespace-nowrap" [ngClass]="{'text-yellow-600': currentStep >= stepInfo.n, 'text-gray-500': currentStep < stepInfo.n}">
                {{ stepInfo.l }}
              </span>
            </div>
            <div *ngIf="!last" class="flex-1 h-1 mx-4" [ngClass]="{'bg-yellow-500': currentStep > stepInfo.n, 'bg-gray-200': currentStep <= stepInfo.n}"></div>
          </ng-container>
        </ng-container>
      </ng-container>
    </div>
  </div>

  <!-- Paso 1: Buscar y seleccionar inscripción -->
  <div *ngIf="currentStep === 1" class="bg-white rounded-lg shadow-md p-6">
    <h2 class="text-lg font-semibold mb-4">Buscar Participante</h2>

    <form [formGroup]="searchForm" (ngSubmit)="searchParticipant()" class="mb-6">
      <div class="flex gap-4">
        <input type="text" formControlName="searchTerm" placeholder="Buscar por nombre o documento..."
          class="flex-1 px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-yellow-500 shadow-sm">
        <button type="submit" [disabled]="isSearching || searchForm.invalid"
          class="px-6 py-2 bg-yellow-500 text-white rounded-lg hover:bg-yellow-600 disabled:bg-gray-400 transition-colors">
          <span *ngIf="isSearching">Buscando...</span>
          <span *ngIf="!isSearching">Buscar</span>
        </button>
      </div>
    </form>

    <!-- Lista de participantes -->
    <div *ngIf="searchPerformed && participants.length > 0" class="mb-6">
      <h3 class="text-sm font-medium text-gray-700 mb-2">Participantes encontrados:</h3>
      <div class="space-y-2 max-h-60 overflow-y-auto">
        <div *ngFor="let p of participants" (click)="selectParticipant(p)"
          [ngClass]="{'ring-2 ring-yellow-500 bg-yellow-50': selectedParticipantId === p.id}"
          class="p-3 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
          <div class="font-medium">{{ p.firstName }} {{ p.lastName }}</div>
          <div class="text-sm text-gray-500">{{ p.typeDocument }}: {{ p.documentId }}</div>
        </div>
      </div>
    </div>

    <!-- Lista de inscripciones (según modo) -->
    <div *ngIf="(wizardMode === 'new' ? enrollments : deferredEnrollments).length > 0" class="mt-6">
      <h3 class="text-sm font-medium text-gray-700 mb-2">
        {{ wizardMode === 'new' ? 'Inscripciones activas:' : 'Inscripciones aplazadas:' }}
      </h3>
      <div class="space-y-3">
        <div *ngFor="let e of (wizardMode === 'new' ? enrollments : deferredEnrollments)" (click)="selectEnrollment(e)"
          [ngClass]="{
            'opacity-50 cursor-not-allowed': (wizardMode === 'new' && !e.canBeDeferred) || (wizardMode === 'continue' && !e.canContinueFromDeferral),
            'border-yellow-200 bg-yellow-50': wizardMode === 'continue'
          }" class="p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors">
          <div class="flex justify-between items-start">
            <div>
              <div class="font-medium">{{ e.projectMnemonic }} - {{ e.projectName }}</div>
              <div class="text-sm text-gray-600">{{ e.participantName }}</div>
            </div>
            <span class="px-2 py-1 text-xs rounded-full" [ngClass]="{
                    'bg-green-100 text-green-800': wizardMode === 'new' && e.canBeDeferred,
                    'bg-yellow-100 text-yellow-800': wizardMode === 'continue',
                    'bg-gray-100 text-gray-600': (wizardMode === 'new' && !e.canBeDeferred)
                  }">
              {{ wizardMode === 'new' ? (e.pendingInstallments + ' cuotas pendientes') : 'Aplazada' }}
            </span>
          </div>
          <div class="mt-2 text-sm">
            <span class="text-gray-600">{{ wizardMode === 'new' ? 'Saldo:' : 'Cartera aplazada:' }} </span>
            <span class="font-medium text-yellow-600">{{ e.currencySymbol }}{{ e.remainingBalance | number:'1.2-2'
              }}</span>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="isLoading" class="text-center py-8">
      <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-yellow-500 mx-auto"></div>
    </div>
  </div>

  <!-- Paso 2: Revisar cuotas / Seleccionar destino -->
  <div *ngIf="currentStep === 2 && selectedEnrollment" class="bg-white rounded-lg shadow-md p-6">

    <!-- Modo Nuevo Aplazamiento: Seleccionar cuotas -->
    <ng-container *ngIf="wizardMode === 'new'">
      <div class="mb-6">
        <h2 class="text-lg font-semibold">Seleccionar Cuotas a Aplazar</h2>
        <p class="text-gray-600">{{ selectedEnrollment.participantName }} - {{ selectedEnrollment.projectName }}</p>
      </div>

      <div class="flex justify-between items-center mb-4">
        <span class="text-sm text-gray-600">Seleccione las cuotas a aplazar:</span>
        <div class="space-x-2">
          <button (click)="selectAllInstallments()" class="text-sm text-yellow-600 hover:text-yellow-800">Seleccionar
            todas</button>
          <button (click)="deselectAllInstallments()"
            class="text-sm text-gray-600 hover:text-gray-800">Deseleccionar</button>
        </div>
      </div>

      <div class="overflow-x-auto">
        <table class="min-w-full divide-y divide-gray-200">
          <thead class="bg-gray-50">
            <tr>
              <th class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">
                <input type="checkbox" [checked]="allInstallmentsSelected" (change)="toggleSelectAll()"
                  class="rounded border-gray-300 text-yellow-500 focus:ring-yellow-500">
              </th>
              <th class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Cuota</th>
              <th class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Vencimiento</th>
              <th class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Monto</th>
              <th class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Pendiente</th>
              <th class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Estado</th>
            </tr>
          </thead>
          <tbody class="bg-white divide-y divide-gray-200">
            <tr *ngFor="let pp of selectedEnrollment.pendingPaymentPlans"
              [ngClass]="{'bg-yellow-50': isInstallmentSelected(pp.paymentPlanId), 'opacity-50': pp.isPunished}">
              <td class="px-4 py-3">
                <input type="checkbox" [checked]="isInstallmentSelected(pp.paymentPlanId)" [disabled]="pp.isPunished"
                  (change)="toggleInstallment(pp.paymentPlanId)"
                  class="rounded border-gray-300 text-yellow-500 focus:ring-yellow-500 disabled:opacity-50">
              </td>
              <td class="px-4 py-3 text-sm font-medium text-gray-900">{{ pp.installmentNumber }}</td>
              <td class="px-4 py-3 text-sm text-gray-500">{{ pp.dueDate | date:'dd/MM/yyyy' }}</td>
              <td class="px-4 py-3 text-sm text-gray-900">{{ selectedEnrollment.currencySymbol }}{{ pp.amountToPay |
                number:'1.2-2' }}</td>
              <td class="px-4 py-3 text-sm text-yellow-600 font-medium">{{ selectedEnrollment.currencySymbol }}{{
                pp.pendingAmount | number:'1.2-2' }}</td>
              <td class="px-4 py-3">
                <span class="px-2 py-1 text-xs rounded-full"
                  [ngClass]="{'bg-yellow-100 text-yellow-800': !pp.isPunished, 'bg-gray-100 text-gray-800': pp.isPunished}">
                  {{ pp.isPunished ? 'Ya aplazada' : pp.paymentStatusDescription }}
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="mt-6 p-4 bg-yellow-50 rounded-lg">
        <div class="flex justify-between items-center">
          <span class="font-medium text-yellow-800">Total a aplazar:</span>
          <span class="text-xl font-bold text-yellow-600">{{ selectedEnrollment.currencySymbol }}{{ selectedTotalAmount
            | number:'1.2-2' }}</span>
        </div>
        <div class="text-sm text-yellow-700 mt-1">{{ selectedInstallments.length }} cuotas seleccionadas</div>
      </div>
    </ng-container>

    <!-- Modo Continuar: Seleccionar destino -->
    <ng-container *ngIf="wizardMode === 'continue'">
      <div class="mb-6">
        <h2 class="text-lg font-semibold">Seleccionar Destino</h2>
        <p class="text-gray-600">{{ selectedEnrollment.participantName }} - Desde: {{ selectedEnrollment.projectName }}</p>
      </div>

      <!-- Resumen de cuotas aplazadas -->
      <div class="mb-6 p-4 bg-yellow-50 rounded-lg">
        <h3 class="font-medium text-yellow-800 mb-2">Cuotas aplazadas:</h3>
        <div class="grid grid-cols-2 gap-4 text-sm">
          <div>
            <span class="text-yellow-700">Cantidad:</span>
            <span class="ml-2 font-medium">{{ deferredInstallments.length }} cuotas</span>
          </div>
          <div>
            <span class="text-yellow-700">Monto total:</span>
            <span class="ml-2 font-medium">{{ selectedEnrollment.currencySymbol }}{{ totalDeferredAmount | number:'1.2-2' }}</span>
          </div>
        </div>
      </div>

      <form [formGroup]="destinationForm">
        <div class="space-y-4">
          <!-- Opción: Mismo proyecto (Reversión de aplazamiento) -->
          <div 
            (click)="destinationForm.patchValue({continueInSameProject: true, newProjectId: null})"
            class="p-4 border rounded-lg cursor-pointer transition-colors"
            [ngClass]="{'border-green-500 bg-green-50': continueInSameProject, 'border-gray-300 hover:bg-gray-50': !continueInSameProject}">
            <div class="flex items-start">
              <input 
                type="radio" 
                formControlName="continueInSameProject"
                [value]="true"
                class="mt-1 text-green-600 focus:ring-green-500">
              <div class="ml-3">
                <label class="font-medium text-gray-900">Continuar en el mismo proyecto</label>
                <p class="text-sm text-gray-500 mt-1">
                  Las cuotas serán descastigadas y la inscripción será reactivada en el proyecto actual: 
                  <strong>{{ selectedEnrollment.projectMnemonic }} - {{ selectedEnrollment.projectName }}</strong>
                </p>
              </div>
            </div>
          </div>

          <!-- Opción: Nuevo proyecto -->
          <div 
            (click)="destinationForm.patchValue({continueInSameProject: false})"
            class="p-4 border rounded-lg cursor-pointer transition-colors"
            [ngClass]="{'border-yellow-500 bg-yellow-50': !continueInSameProject, 'border-gray-300 hover:bg-gray-50': continueInSameProject}">
            <div class="flex items-start">
              <input 
                type="radio" 
                formControlName="continueInSameProject"
                [value]="false"
                class="mt-1 text-yellow-600 focus:ring-yellow-500">
              <div class="ml-3 flex-1">
                <label class="font-medium text-gray-900">Crear nueva inscripción en otro proyecto</label>
                <p class="text-sm text-gray-500 mt-1 mb-3">
                  Se creará una nueva inscripción y las cuotas pendientes serán migradas al nuevo proyecto.
                </p>
                <div *ngIf="!continueInSameProject">
                  <label class="block text-sm font-medium text-gray-700 mb-1">Seleccionar nuevo proyecto *</label>
                  <p-dropdown 
                    formControlName="newProjectId" 
                    [options]="projects" 
                    optionLabel="name" 
                    optionValue="id"
                    [filter]="true" 
                    filterBy="name,projectId" 
                    placeholder="-- Seleccionar proyecto --" 
                    styleClass="w-full"
                    [showClear]="true">
                    <ng-template let-project pTemplate="item">
                      <div class="flex flex-col">
                        <span class="font-medium">{{project.name}}</span>
                        <span class="text-xs text-gray-500">{{project.projectId}}</span>
                      </div>
                    </ng-template>
                  </p-dropdown>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </ng-container>

    <div class="flex justify-between mt-6">
      <button (click)="prevStep()" class="px-6 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50">
        Anterior
      </button>
      <button (click)="nextStep()"
        [disabled]="(wizardMode === 'new' && selectedInstallments.length === 0) || (wizardMode === 'continue' && !isDestinationValid())"
        class="px-6 py-2 text-white rounded-lg hover:opacity-90 disabled:bg-gray-400"
        [ngClass]="{'bg-green-500': wizardMode === 'continue' && continueInSameProject, 'bg-yellow-500': wizardMode !== 'continue' || !continueInSameProject}">
        Continuar
      </button>
    </div>
  </div>

  <!-- Paso 3 (Continue - Nuevo Proyecto): Modificar Valor -->
  <div *ngIf="currentStep === 3 && wizardMode === 'continue' && !continueInSameProject" class="bg-white rounded-lg shadow-md p-6">
    <div class="mb-6">
      <h2 class="text-lg font-semibold">Modificar Valor de Inscripción</h2>
      <p class="text-gray-600">Puede ajustar el valor total que se transferirá a la nueva inscripción.</p>
    </div>

    <!-- Referencia de valores del proyecto -->
    <div class="bg-gray-50 p-4 rounded-lg mb-6">
      <p class="text-sm text-gray-500 mb-2">Valores base del proyecto seleccionado:</p>
      <div class="grid grid-cols-2 gap-4">
        <div>
          <span class="text-gray-600 text-sm">COP:</span>
          <span class="font-medium ml-2">{{ (getSelectedProject()?.inscriptionAmountCOP || getSelectedProject()?.inscriptionAmount || 0) | currency:'COP':'symbol-narrow':'1.0-0' }}</span>
        </div>
        <div>
          <span class="text-gray-600 text-sm">USD:</span>
          <span class="font-medium ml-2">{{ (getSelectedProject()?.inscriptionAmountUSD || 0) | currency:'USD':'symbol-narrow':'1.2-2' }}</span>
        </div>
      </div>
      <button type="button" (click)="autofillFromProject()" 
              class="mt-3 text-sm text-blue-600 hover:text-blue-800 flex items-center gap-1">
        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"/>
        </svg>
        Usar valores del proyecto
      </button>
    </div>

    <!-- Referencia del valor aplazado original -->
    <div class="bg-yellow-50 p-4 rounded-lg mb-6 border-l-4 border-yellow-400">
      <p class="text-sm text-yellow-700">
        <strong>Valor aplazado original:</strong> {{ selectedEnrollment?.currencySymbol }}{{ totalDeferredAmount | number:'1.2-2' }}
      </p>
    </div>

    <form [formGroup]="valueForm">
      <!-- Inputs duales COP y USD -->
      <div class="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
        <div>
          <label class="block text-sm font-semibold text-gray-700 mb-2">Valor en COP *</label>
          <input type="text" formControlName="newTotalValueCOP" appCurrencyFormatter
            class="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
            placeholder="$ 0">
        </div>
        <div>
          <label class="block text-sm font-semibold text-gray-700 mb-2">Valor en USD</label>
          <input type="text" formControlName="newTotalValueUSD" appCurrencyFormatter
            class="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
            placeholder="USD$ 0">
        </div>
      </div>

      <!-- Selector de moneda principal -->
      <div class="mb-6">
        <label class="block text-sm font-medium text-gray-700 mb-1">Moneda principal para las cuotas</label>
        <p-dropdown 
          formControlName="currencyId"
          [options]="[{label: 'COP - Pesos Colombianos', value: 1}, {label: 'USD - Dólares Estadounidenses', value: 2}]"
          optionLabel="label"
          optionValue="value"
          styleClass="w-full"
          placeholder="Seleccionar moneda">
        </p-dropdown>
        <p class="text-sm text-gray-500 mt-1">Las cuotas del plan de pagos se calcularán en esta moneda.</p>
      </div>
    </form>

    <div class="flex justify-between mt-6">
      <button (click)="prevStep()" class="px-6 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50">
        Anterior
      </button>
      <button (click)="nextStep()" [disabled]="getActiveTotal() <= 0"
        class="px-6 py-2 bg-yellow-500 text-white rounded-lg hover:bg-yellow-600 disabled:bg-gray-400">
        Continuar
      </button>
    </div>
  </div>

  <!-- Paso 4 (Continue - Nuevo Proyecto): Modificar Plan de Pagos -->
  <div *ngIf="currentStep === 4 && wizardMode === 'continue' && !continueInSameProject" class="bg-white rounded-lg shadow-md p-6">
    <div class="mb-6 flex justify-between items-start">
      <div>
        <h2 class="text-lg font-semibold">Configurar Nuevo Plan de Pagos</h2>
        <p class="text-gray-600">Defina las cuotas para la nueva inscripción.</p>
      </div>
      <div class="flex items-center gap-3">
        <div class="text-right mr-4">
          <div class="text-sm text-gray-500">Total a cubrir</div>
          <div class="text-xl font-bold text-gray-800">
            {{ valueForm.get('currencyId')?.value === 1 ? (getActiveTotal() | currency:'COP':'symbol-narrow':'1.0-0') : (getActiveTotal() | currency:'USD':'symbol-narrow':'1.2-2') }}
          </div>
        </div>
        <button type="button" (click)="openRefinanceModal()"
          class="bg-green-100 hover:bg-green-200 text-green-700 px-4 py-2 rounded-md text-sm font-medium transition-colors flex items-center gap-2">
          <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
            <path fill-rule="evenodd"
              d="M4 2a1 1 0 011 1v2.101a7.002 7.002 0 0111.601 2.566 1 1 0 11-1.885.666A5.002 5.002 0 005.999 7H9a1 1 0 010 2H4a1 1 0 01-1-1V3a1 1 0 011-1zm.008 9.057a1 1 0 011.276.61A5.002 5.002 0 0014.001 13H11a1 1 0 110-2h5a1 1 0 011 1v5a1 1 0 11-2 0v-2.101a7.002 7.002 0 01-11.601-2.566 1 1 0 01.61-1.276z"
              clip-rule="evenodd"></path>
          </svg>
          Generar Automáticamente
        </button>
      </div>
    </div>

    <!-- Lista de cuotas -->
    <div class="mb-4">
      <table class="min-w-full divide-y divide-gray-200">
        <thead class="bg-gray-50">
          <tr>
            <th class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">No.</th>
            <th class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Fecha Vencimiento</th>
            <th class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Valor</th>
            <th class="px-4 py-3 text-right"></th>
          </tr>
        </thead>
        <tbody class="divide-y divide-gray-200">
          <tr *ngFor="let installment of newPaymentPlan; let i = index">
            <td class="px-4 py-2 font-medium">{{ installment.installmentNumber }}</td>
            <td class="px-4 py-2">
              <p-calendar [(ngModel)]="installment.dueDate" dateFormat="dd/mm/yy" [showIcon]="true" appendTo="body"
                class="w-full calendar-field">
              </p-calendar>
            </td>
            <td class="px-4 py-2">
              <input type="text" [(ngModel)]="installment.amount" appCurrencyFormatter
                class="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                placeholder="0">
            </td>
            <td class="px-4 py-2 text-right">
              <button (click)="removeInstallment(i)" class="text-red-500 hover:text-red-700" title="Eliminar cuota">
                <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                </svg>
              </button>
            </td>
          </tr>
        </tbody>
        <tfoot class="bg-gray-50">
          <tr>
            <td colspan="2" class="px-4 py-3 text-right font-medium">Total Plan:</td>
            <td class="px-4 py-3 font-bold" [ngClass]="{'text-green-600': isPlanValid, 'text-red-600': !isPlanValid}">
              {{ selectedEnrollment?.currencySymbol }}{{ currentPlanTotal | number:'1.2-2' }}
            </td>
            <td></td>
          </tr>
        </tfoot>
      </table>
    </div>

    <div class="flex justify-between items-center mb-6">
      <div *ngIf="!isPlanValid" class="text-sm text-red-600 flex items-center">
        <svg class="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
        La suma de las cuotas debe ser igual al valor total de la inscripción.
      </div>
      <div *ngIf="isPlanValid" class="text-sm text-green-600 flex items-center">
        <svg class="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
        </svg>
        Plan de pagos válido.
      </div>

      <button (click)="addInstallment()"
        class="ml-auto px-4 py-2 border border-yellow-500 text-yellow-600 rounded-lg hover:bg-yellow-50 flex items-center">
        <svg class="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4" />
        </svg>
        Agregar Cuota
      </button>
    </div>

    <div class="flex justify-between mt-6">
      <button (click)="prevStep()" class="px-6 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50">
        Anterior
      </button>
      <button (click)="nextStep()" [disabled]="!isPlanValid"
        class="px-6 py-2 bg-yellow-500 text-white rounded-lg hover:bg-yellow-600 disabled:bg-gray-400">
        Continuar
      </button>
    </div>
  </div>

  <!-- Paso Confirmar (Step 3 or 5) -->
  <div *ngIf="currentStep === (finalStepIndex - 1) && selectedEnrollment" class="bg-white rounded-lg shadow-md p-6">
    <h2 class="text-lg font-semibold mb-4">
      Confirmar {{ wizardMode === 'new' ? 'Aplazamiento' : (continueInSameProject ? 'Reversión de Aplazamiento' : 'Continuación') }}
    </h2>

    <!-- Resumen -->
    <div class="bg-gray-50 rounded-lg p-4 mb-6">
      <h3 class="font-medium text-gray-700 mb-2">Resumen</h3>
      <div class="grid grid-cols-2 gap-4 text-sm">
        <div>
          <span class="text-gray-500">Participante:</span>
          <span class="ml-2 font-medium">{{ selectedEnrollment.participantName }}</span>
        </div>
        <div>
          <span class="text-gray-500">Proyecto {{ wizardMode === 'new' ? '' : 'original' }}:</span>
          <span class="ml-2 font-medium">{{ selectedEnrollment.projectMnemonic }}</span>
        </div>

        <!-- Info Nuevo Aplazamiento -->
        <ng-container *ngIf="wizardMode === 'new'">
          <div>
            <span class="text-gray-500">Cuotas:</span>
            <span class="ml-2 font-medium">{{ selectedInstallments.length }}</span>
          </div>
          <div>
            <span class="text-gray-500">Monto total:</span>
            <span class="ml-2 font-medium text-yellow-600">
              {{ selectedEnrollment.currencySymbol }}{{ selectedTotalAmount | number:'1.2-2' }}
            </span>
          </div>
        </ng-container>

        <!-- Info Continuar - Mismo Proyecto -->
        <ng-container *ngIf="wizardMode === 'continue' && continueInSameProject">
          <div class="col-span-2">
            <span class="text-gray-500">Acción:</span>
            <span class="ml-2 font-medium text-green-600">Reactivar inscripción en el mismo proyecto</span>
          </div>
          <div>
            <span class="text-gray-500">Cuotas a descastigar:</span>
            <span class="ml-2 font-medium">{{ deferredInstallments.length }}</span>
          </div>
          <div>
            <span class="text-gray-500">Monto total:</span>
            <span class="ml-2 font-medium text-green-600">
              {{ selectedEnrollment.currencySymbol }}{{ totalDeferredAmount | number:'1.2-2' }}
            </span>
          </div>
        </ng-container>

        <!-- Info Continuar - Nuevo Proyecto -->
        <ng-container *ngIf="wizardMode === 'continue' && !continueInSameProject">
          <div class="col-span-2">
            <span class="text-gray-500">Nuevo proyecto:</span>
            <span class="ml-2 font-medium text-blue-600">{{ getSelectedProject()?.projectId }} - {{
              getSelectedProject()?.name }}</span>
          </div>
          <div>
            <span class="text-gray-500">Nuevo Valor:</span>
            <span class="ml-2 font-medium text-yellow-600">
              {{ valueForm.get('currencyId')?.value === 1 ? (getActiveTotal() | currency:'COP':'symbol-narrow':'1.0-0') : (getActiveTotal() | currency:'USD':'symbol-narrow':'1.2-2') }}
            </span>
          </div>
          <div>
            <span class="text-gray-500">Cuotas nuevas:</span>
            <span class="ml-2 font-medium">{{ newPaymentPlan.length }}</span>
          </div>
        </ng-container>
      </div>
    </div>

    <form [formGroup]="confirmForm" (ngSubmit)="submitDeferral()">
      <div class="mb-4">
        <label class="block text-sm font-medium text-gray-700 mb-1">
          Razón {{ wizardMode === 'new' ? 'del aplazamiento' : (continueInSameProject ? 'de la reversión' : 'de la continuación') }} *
        </label>
        <textarea formControlName="reason" rows="3" placeholder="Ingrese la razón (mínimo 10 caracteres)"
          class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-yellow-500">
        </textarea>
      </div>

      <div class="mb-6">
        <label class="block text-sm font-medium text-gray-700 mb-1">Notas adicionales (opcional)</label>
        <textarea formControlName="notes" rows="2" placeholder="Notas adicionales para auditoría"
          class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-yellow-500">
        </textarea>
      </div>

      <!-- Advertencia -->
      <div class="bg-yellow-50 border-l-4 border-yellow-400 p-4 mb-6">
        <div class="flex">
          <div class="flex-shrink-0">
            <svg class="h-5 w-5 text-yellow-400" fill="currentColor" viewBox="0 0 20 20">
              <path fill-rule="evenodd"
                d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
                clip-rule="evenodd" />
            </svg>
          </div>
          <div class="ml-3">
            <p class="text-sm text-yellow-700" *ngIf="wizardMode === 'new'">
              <strong>Importante:</strong> El aplazamiento castigará temporalmente las cuotas seleccionadas.
              Cuando el estudiante desee continuar, las cuotas podrán ser migradas a una nueva inscripción.
            </p>
            <p class="text-sm text-green-700" *ngIf="wizardMode === 'continue' && continueInSameProject">
              <strong>Importante:</strong> Se descastigarán las cuotas aplazadas y la inscripción será reactivada.
              El estudiante continuará sus estudios en el proyecto actual sin crear una nueva inscripción.
            </p>
            <p class="text-sm text-yellow-700" *ngIf="wizardMode === 'continue' && !continueInSameProject">
              <strong>Importante:</strong> Se creará una nueva inscripción automática con un valor de 
              {{ valueForm.get('currencyId')?.value === 1 ? (getActiveTotal() | currency:'COP':'symbol-narrow':'1.0-0') : (getActiveTotal() | currency:'USD':'symbol-narrow':'1.2-2') }}.
              El estudiante continuará sus estudios en el nuevo proyecto.
            </p>
          </div>
        </div>
      </div>

      <div class="flex justify-between">
        <button type="button" (click)="prevStep()"
          class="px-6 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50">
          Anterior
        </button>
        <div class="flex items-center gap-3">
          <button type="button" (click)="cancel()"
            class="px-6 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50">
            Cancelar
          </button>
          <button type="submit" [disabled]="confirmForm.invalid || isSubmitting"
            class="px-6 py-2 bg-yellow-500 text-white rounded-lg hover:bg-yellow-600 disabled:bg-gray-400 inline-flex items-center gap-2">
            <svg *ngIf="isSubmitting" class="animate-spin h-5 w-5" fill="none" viewBox="0 0 24 24">
              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
              <path class="opacity-75" fill="currentColor"
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
              </path>
            </svg>
            <span *ngIf="isSubmitting">Procesando...</span>
            <span *ngIf="!isSubmitting">
              Confirmar {{ wizardMode === 'new' ? 'Aplazamiento' : (continueInSameProject ? 'Reversión' : 'Continuación') }}
            </span>
          </button>
        </div>
      </div>
    </form>
  </div>

  <!-- Paso Final: Resultado -->
  <div *ngIf="currentStep === finalStepIndex" class="bg-white rounded-lg shadow-md p-6">
    <!-- Éxito -->
    <div *ngIf="operationSuccess" class="text-center">
      <div class="mx-auto flex items-center justify-center h-20 w-20 rounded-full mb-6"
        [ngClass]="{'bg-yellow-100': wizardMode === 'new', 'bg-green-100': wizardMode === 'continue'}">
        <svg class="h-12 w-12" fill="none" stroke="currentColor" viewBox="0 0 24 24"
          [ngClass]="{'text-yellow-600': wizardMode === 'new', 'text-green-600': wizardMode === 'continue'}">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
        </svg>
      </div>
      <h2 class="text-2xl font-bold text-gray-900 mb-2">
        ¡{{ wizardMode === 'new' ? 'Aplazamiento' : 'Continuación' }} Procesado Exitosamente!
      </h2>
      <p class="text-gray-600 mb-6">{{ operationResult?.message }}</p>

      <!-- Resumen de la operación -->
      <div class="bg-gray-50 rounded-lg p-6 text-left mb-6 max-w-lg mx-auto">
        <h3 class="font-semibold text-gray-800 mb-4 flex items-center gap-2">
          <svg class="w-5 h-5 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
          </svg>
          Resumen de la Operación
        </h3>
        <div class="space-y-3">
          <div class="flex justify-between items-center py-2 border-b border-gray-200">
            <span class="text-gray-600">Participante:</span>
            <span class="font-medium">{{ selectedEnrollment?.participantName }}</span>
          </div>
          <div class="flex justify-between items-center py-2 border-b border-gray-200">
            <span class="text-gray-600">Proyecto {{ wizardMode === 'continue' ? 'Original' : '' }}:</span>
            <span class="font-medium">{{ selectedEnrollment?.projectMnemonic }}</span>
          </div>
          <div class="flex justify-between items-center py-2 border-b border-gray-200"
            *ngIf="operationResult?.newEnrollmentId">
            <span class="text-gray-600">Nueva Inscripción:</span>
            <span class="font-medium text-blue-600">#{{ operationResult?.newEnrollmentId }}</span>
          </div>
          <div class="flex justify-between items-center py-2 border-b border-gray-200"
            *ngIf="wizardMode === 'continue'">
            <span class="text-gray-600">Nuevo Proyecto:</span>
            <span class="font-medium">{{ getSelectedProject()?.projectId }} - {{ getSelectedProject()?.name }}</span>
          </div>
          <div class="flex justify-between items-center py-2 border-b border-gray-200">
            <span class="text-gray-600">Cuotas {{ wizardMode === 'new' ? 'Aplazadas' : 'Migradas' }}:</span>
            <span class="font-medium"
              [ngClass]="{'text-yellow-600': wizardMode === 'new', 'text-green-600': wizardMode === 'continue'}">
              {{ operationResult?.affectedInstallmentsCount }} cuota(s)
            </span>
          </div>
          <div class="flex justify-between items-center py-2 border-b border-gray-200">
            <span class="text-gray-600">Monto Total:</span>
            <span class="font-bold"
              [ngClass]="{'text-yellow-600': wizardMode === 'new', 'text-green-600': wizardMode === 'continue'}">
              {{ selectedEnrollment?.currencySymbol }}{{ operationResult?.totalAffectedAmount | number:'1.2-2' }}
            </span>
          </div>
          <div class="flex justify-between items-center py-2">
            <span class="text-gray-600">Nuevo Estado:</span>
            <span class="px-3 py-1 rounded-full text-sm font-medium"
              [ngClass]="{'bg-yellow-100 text-yellow-800': wizardMode === 'new', 'bg-green-100 text-green-800': wizardMode === 'continue'}">
              {{ wizardMode === 'new' ? 'Aplazada' : 'Activa' }}
            </span>
          </div>
        </div>
      </div>

      <!-- Botones de acción -->
      <div class="flex flex-col sm:flex-row gap-3 justify-center">
        <button (click)="viewEnrollment()"
          class="px-6 py-2 text-white rounded-lg flex items-center justify-center gap-2"
          [ngClass]="{'bg-yellow-500 hover:bg-yellow-600': wizardMode === 'new', 'bg-green-600 hover:bg-green-700': wizardMode === 'continue'}">
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
          </svg>
          {{ operationResult?.newEnrollmentId ? 'Ver Nueva Inscripción' : 'Ver Inscripción' }}
        </button>
        <button *ngIf="operationResult?.newEnrollmentId" (click)="viewOriginalEnrollment()"
          class="px-6 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 flex items-center justify-center gap-2">
          Ver Inscripción Original
        </button>
        <button (click)="startNewDeferral()"
          class="px-6 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 flex items-center justify-center gap-2">
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4" />
          </svg>
          Nueva Operación
        </button>
        <button (click)="goToEnrollmentsList()"
          class="px-6 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 flex items-center justify-center gap-2">
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 10h16M4 14h16M4 18h16" />
          </svg>
          Lista de Inscripciones
        </button>
      </div>
    </div>

    <!-- Error -->
    <div *ngIf="!operationSuccess" class="text-center">
      <div class="mx-auto flex items-center justify-center h-20 w-20 rounded-full bg-red-100 mb-6">
        <svg class="h-12 w-12 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </div>
      <h2 class="text-2xl font-bold text-gray-900 mb-2">Error al Procesar la Operación</h2>
      <p class="text-red-600 mb-6">{{ operationError }}</p>

      <div class="flex flex-col sm:flex-row gap-3 justify-center">
        <button (click)="currentStep = (finalStepIndex - 1)"
          class="px-6 py-2 bg-yellow-500 text-white rounded-lg hover:bg-yellow-600 flex items-center justify-center gap-2">
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 19l-7-7m0 0l7-7m-7 7h18" />
          </svg>
          Volver a Intentar
        </button>
        <button (click)="goToEnrollmentsList()"
          class="px-6 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50">
          Cancelar
        </button>
      </div>
    </div>
  </div>

  <!-- 🆕 Modal de Refinanciación -->
  <div *ngIf="showRefinanceModal" class="fixed inset-0 z-50 flex items-center justify-center bg-gray-950/60 p-4">
    <div class="w-full max-w-md rounded-xl border border-gray-200 bg-white p-8 shadow-2xl">
      <div class="flex items-start justify-between">
        <div>
          <h2 class="text-lg font-semibold text-gray-900">Generar Plan de Pagos</h2>
          <p class="mt-1 text-sm text-gray-500">Distribuya automáticamente el valor total en cuotas mensuales.</p>
        </div>
        <button (click)="closeRefinanceModal()" class="rounded-full p-2 text-gray-400 transition hover:text-gray-600">
          <svg class="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
          </svg>
        </button>
      </div>

      <div class="mt-6 space-y-6">
        <div class="rounded-lg border border-gray-200 bg-gray-50 p-4">
          <p class="text-xs font-medium uppercase tracking-wide text-gray-500">Valor total a distribuir</p>
          <p class="mt-2 text-2xl font-semibold text-gray-900">
            {{ valueForm.get('currencyId')?.value === 1 ? (getActiveTotal() | currency:'COP':'symbol-narrow':'1.0-0') : (getActiveTotal() | currency:'USD':'symbol-narrow':'1.2-2') }}
          </p>
          <p class="mt-1 text-sm text-gray-600">Este monto se distribuirá automáticamente en las cuotas seleccionadas.
          </p>
        </div>

        <div class="space-y-3">
          <label class="text-sm font-semibold text-gray-900">¿En cuántas cuotas desea distribuir?</label>
          <div class="flex items-center gap-4">
            <button type="button" (click)="refinanceInstallments = Math.max(minInstallments, refinanceInstallments - 1)"
              [disabled]="refinanceInstallments <= minInstallments"
              class="flex h-10 w-10 items-center justify-center rounded-full border border-gray-200 bg-white text-base font-semibold text-gray-700 transition hover:bg-gray-100 disabled:opacity-60">
              −
            </button>
            <div class="text-center">
              <input type="number" [(ngModel)]="refinanceInstallments" [min]="minInstallments" [max]="maxInstallments"
                class="w-24 rounded-lg border border-gray-200 bg-white py-2 text-center text-xl font-semibold text-gray-900 focus:border-gray-400 focus:outline-none focus:ring-2 focus:ring-gray-200">
              <div class="mt-1 text-xs text-gray-500">Cuotas</div>
            </div>
            <button type="button" (click)="refinanceInstallments = Math.min(maxInstallments, refinanceInstallments + 1)"
              [disabled]="refinanceInstallments >= maxInstallments"
              class="flex h-10 w-10 items-center justify-center rounded-full border border-gray-200 bg-white text-base font-semibold text-gray-700 transition hover:bg-gray-100 disabled:opacity-60">
              +
            </button>
          </div>
          <p class="text-center text-xs text-gray-500">Rango permitido: {{ minInstallments }} - {{ maxInstallments }}
            cuotas</p>
        </div>

        <div class="rounded-lg border border-gray-200 bg-white p-4">
          <div class="flex items-center justify-between text-sm text-gray-600">
            <span>Estimado por cuota</span>
            <span class="text-lg font-semibold text-gray-900">{{ getEstimatedInstallmentAmount() | currency:'COP'
              }}</span>
          </div>
          <p class="mt-2 text-xs text-gray-500">La última cuota puede variar ligeramente para ajustar diferencias de
            redondeo.</p>
        </div>

        <div class="rounded-lg border border-gray-200 bg-gray-50 p-4 text-sm text-gray-600">
          <span class="font-semibold text-gray-900">Importante:</span> Esta acción eliminará todas las cuotas actuales y
          creará un nuevo plan de pagos con fechas mensuales consecutivas.
        </div>
      </div>

      <div class="mt-6 flex flex-col gap-3 sm:flex-row">
        <button type="button" (click)="closeRefinanceModal()"
          class="inline-flex flex-1 items-center justify-center rounded-full border border-gray-200 bg-white px-4 py-2 text-sm font-semibold text-gray-700 transition hover:bg-gray-100">
          Cancelar
        </button>
        <button type="button" (click)="confirmRefinance()"
          [disabled]="refinanceInstallments < minInstallments || refinanceInstallments > maxInstallments"
          class="inline-flex flex-1 items-center justify-center rounded-full border border-gray-900 bg-gray-900 px-4 py-2 text-sm font-semibold text-white transition hover:bg-gray-800 disabled:border-gray-200 disabled:bg-gray-100 disabled:text-gray-400">
          Confirmar generación
        </button>
      </div>
    </div>
  </div>
</div>